import { FormattedMessage } from 'react-intl';
import { boolean, InferType, number, object, string, ref } from 'yup';

import {
  MAX_NAME_LENGTH,
  withPasswordValidation,
  withPersonNameValidation,
} from '@/shared/config';

export const inviteSignUpFormSchema = object({
  firstName: withPersonNameValidation(string()).required().max(MAX_NAME_LENGTH),
  lastName: withPersonNameValidation(string()).required().max(MAX_NAME_LENGTH),
  password: withPasswordValidation(string().required()),
  confirmPassword: string()
    .oneOf([ref('password')], () => (
      <FormattedMessage
        id="signUp.passwordsMustMatch"
        defaultMessage="Passwords must match"
      />
    ))
    .required(),
  language: number().required(),
  termsAndConditions: boolean().oneOf([true]).required(),
  privacyPolicy: boolean().oneOf([true]).required(),
  marketingCommunicationConsent: boolean(),
});

export type InviteSignUpFormPayload = InferType<typeof inviteSignUpFormSchema>;
